import { UPDATE_QUICK_VIEW_PRICING } from './actionTypes';

export const updateQuickViewPricing = payload => ({ type: UPDATE_QUICK_VIEW_PRICING, payload });
